import React from "react";
import { Helmet } from "react-helmet-async";
import featureFlags from "utils/featureFlags";

const cookieBannerScript = (
  <script
    type="text/javascript"
    src="//cdn.cookie-script.com/s/7f07d68cc3a1cdc2eebcab29b7d59a08.js"
  />
);

const globalHeaderScript = (
  <script
    id="elexon-global-widgets-script"
    src="https://login.elexon.co.uk/elexon-global-widgets.js"
    async
  />
);

const globalHeaderScriptStaging = (
  <script
    id="elexon-global-widgets-script"
    src="https://login-staging.elexon.co.uk/elexon-global-widgets-staging.js"
    async
  />
);

const GlobalMeta: React.FC = () => {
  const doNotIndex = process.env.REACT_APP_ENV_PREFIX !== "prod";
  const useProdGlobalHeader =
    process.env.REACT_APP_ENV_PREFIX === "prod" ||
    process.env.REACT_APP_ENV_PREFIX === "test";
  return (
    <Helmet>
      {featureFlags.cookieBanner && <>{cookieBannerScript}</>}
      {featureFlags.rebrand && (
        <>
          {useProdGlobalHeader ? globalHeaderScript : globalHeaderScriptStaging}
        </>
      )}
      {doNotIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

export default GlobalMeta;
